import * as React from 'react'
import { GDataContext, GDataContextManager } from './GDataContext';
import { GraphDataset } from './models/GraphDataset.interface';



type Props = {
  children: any,
}


const GDataBaseProvider = ({
  children,
}: Props) => {
  const [base, setBase] = React.useState<GraphDataset>(null);
  const [createdAt, setCreatedAt] = React.useState<Date>(null);
  const [hasError, setHasError] = React.useState<boolean>(false);

  async function downloadGraph() {
    /**
     * Try brotli compression first. If it doesn't work try gzip.
     */
    try {
      const res = await fetch('https://storage.googleapis.com/lnrouter-public/lnrouter.app/graph.json');
      const json = await res.json();
      return json;
    } catch (e) {
      const res = await fetch('https://storage.googleapis.com/lnrouter-public/lnrouter.app/graph.json.gzip');
      const json = await res.json();
      return json;
    }

  }

  async function fetchData() {
    try {
      setHasError(false);
      const json = await downloadGraph();
      setBase(json);
      setCreatedAt(new Date(json.createdAt));
    } catch (e) {
      console.error(e);
      setHasError(true);
    }

  }

  React.useEffect(() => {
    if (!base) {
      fetchData();
    }
  }, [])

  return (
    <GDataContext.Provider value={new GDataContextManager(base, createdAt, hasError, () => fetchData())}>
      {children}
    </GDataContext.Provider>
  );
};

export default GDataBaseProvider;